export default __webpack_public_path__ + "static/kurorty-img-11-031cd79ce6f5a52fe0b8296f0f13b08e.png";